export default {
  PREDEFINED_LABELS(state, { data }) {
    state.predefinedLabels = data;
  },
};
